import { cn } from '../../utils/cn'

export default function SegmentedTabs({
  tabs = [],
  active,
  onChange,
  className,
  activeClass = 'bg-[#454545] text-white font-titillium-web-semibold',
}) {
  return (
    <div
      role="tablist"
      className={cn('flex flex-wrap items-center gap-x-10 gap-y-4', className)}
    >
      {tabs.map(tab => {
        const isActive = tab.id === active

        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange?.(tab.id)}
            className={cn(
              'flex h-12 cursor-pointer items-center justify-center rounded-full px-8 text-lg uppercase transition-colors duration-200 lg:h-14 lg:px-20 lg:text-2xl',
              isActive
                ? activeClass
                : 'border border-[#C7C7C7] text-[#BEBEBE] font-titillium-web-regular',
            )}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}
